$(document).ready(function() {

  $('.addtocart_bundle,  .doors-design-atc-solid').on('click',function(e) {
  e.preventDefault();
  $('.addtocart_bundle, .doors-design-atc-solid ').css('pointer-events', 'none');
  $('.doors-design-atc-solid span').html('');
  $('.doors-design-atc-solid span').html('Adding to cart...');
   var selected_products = []
    $('.doors-design-product-form-price').each(function(){
      var variant_id = $(this).data('variant_id');
      
      if(variant_id){
      var current_variants = {'id':variant_id , 'quantity':1}
              selected_products.push(current_variants);
      }
      });
 
  $.ajax({
    type: 'POST',
    url: 'https://rishit57.sg-host.com/cart_bundle/cart_bundle.php',
    data: {items:selected_products},
    success: function(response) {
      console.log(response);
      var propertiesArray = [];
      $('.product_properties').each(function(){
        var properties = $(this).data('property_type');
        var propval = $(this).data('property_value');
        propertiesArray.push({ type: properties, value: propval });
      });
      var propertiesObject = {};
      propertiesArray.forEach(function(item) {
        propertiesObject[item.type] = item.value;
      });
      
      var properties = propertiesObject;
      var Quantity = $('.quantityselector').val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {'id': JSON.parse(response), 
               'quantity':Quantity,
               'properties': properties
              },
        
        success: function(response) {
          $('.doors-design-atc-solid span').html('Added to Cart');
          setTimeout(function() {
          $('.doors-design-atc-solid span').html('Add to Cart');  
          },1000);
          setTimeout(function() {
          window.location.href = '/cart';  
          },2000);
        }
      })
    },
    error: function(xhr, status, error) {
      console.error('Error adding product to cart:', error);
    }
  });
});


const form = document.getElementById('doors-design-multi-step-form');
const steps = Array.from(form.getElementsByClassName('doors-design-step'));
const selectedValuesList = document.getElementById('selected-values');
const progressBar = document.querySelector('.doors-design-progress-bar');
const ValuesContainer = document.querySelector('.doors-design-values-container');
let currentStep = 0;

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

 updateStepVisibility();

function updateStepVisibility() {
    if ($(".reset-step-form").length > 0) {
      currentStep = 0;
      $("body").removeClass("reset-step-form");
    }    
    progressBar.setAttribute('data-step', currentStep);
    ValuesContainer.setAttribute('data-step', currentStep);
    steps.forEach((step, index) => {
        step.style.display = index === currentStep ? 'block' : 'none';        
    });
}

function prevStep() {
    if (currentStep > 0) {
        currentStep--;
        updateStepVisibility();
    }
}
  $('.doors-design-nav-back').on('click',function(){
    prevStep();
  });

function nextStep() {
    if (currentStep < steps.length - 1) {
        currentStep++;
        updateStepVisibility();
    }
}
  $(document).on('click','.incr, .decr',function(){
    var qty = $(this).parent().find('.quantityselector').val();
    $('[name="quantity"]').val(qty);
  });

  // $(document).on('click',', ',function(){
  //   $('#doors-design-product-form').trigger('clicks');
  // });
     var total = 0;
    $(document).on('click',"#doors-design-multi-step-form input[type='radio']",function() {
      // $('.addtocart_bundle ').css('pointer-events', 'all');
      var calculated_price = parseFloat($(this).data("price"));
      if(calculated_price){
      total += calculated_price; 
        
        $(".doors-design-value-price, .doors-design-final-price").text(Shopify.formatMoney(total));
        }
      var configurationValue = $(this).data('option-title');
        var Value = $(this).val();
        var variant_ID = $(this).data('variant-id');
        // var price = $(this).data('price');
        // console.log(variant_ID);
        var total_amount = $(this).data('price');
        var price_main = Shopify.formatMoney(total_amount);
        
        $('.doors-design-field-flex[data-title="'+ configurationValue +'"]').css("display", "flex");
        
        $('.doors-design-product-option-value[data-value="'+ configurationValue +'"]').text(Value);
        $('.doors-design-product-form-price[data-value="'+ configurationValue +'"]').text(price_main);
        $('.doors-design-product-form-price[data-value="'+ configurationValue +'"]').attr('data-variant_id',variant_ID);
         if(total_amount){
          $('.doors-design-field-flex input[name="properties['+ configurationValue +']"').attr('data-property_value', Value + ' :'+price_main);
        }else{
          $('.doors-design-field-flex input[name="properties['+ configurationValue +']"').attr('data-property_value', Value);
        }
        $('.doors-design-field-flex input[name="properties['+ configurationValue +']"').val(Value);
        if(configurationValue == 'Height / Act') {
          $(".doors-cst-height-form-open").css("display", "none");
          $(".doors-cst-height-label").removeClass("active");
        }
        if(configurationValue == 'Width / Act') {
          $(".doors-cst-width-form-open").css("display", "none");
          $(".doors-cst-width-label").removeClass("active");
        }
        nextStep();
    });
    $(document).on('click',".doors-cst-height-btn-open",function() {
      $(".doors-cst-height-form-open").css("display", "flex");
      $(".doors-cst-height-label").addClass("active");
    });
    $(document).on('click',".doors-design-cst-height-cancel-btn",function() {
      $(".doors-cst-height-form-open").css("display", "none");
      $(".doors-cst-height-label").removeClass("active");
    });
    $(document).on('click',".doors-design-cst-height-apply-btn",function() {
      var inputheight = $(".doors-design-height-inch").val();
      var selectfaction = $(".custom_height_fraction").val();
      if (inputheight !== "" && selectfaction !== null) {
        $(".doors-cst-height").val(inputheight + ' / ' + selectfaction);  
        $(".doors-cst-height").click();
      }       
    });
  
    $(document).on('click',".doors-cst-width-btn-open",function() {
      $(".doors-cst-width-form-open").css("display", "flex");
      $(".doors-cst-width-label").addClass("active");
    });
    $(document).on('click',".doors-design-cst-width-cancel-btn",function() {
      $(".doors-cst-width-form-open").css("display", "none");
      $(".doors-cst-width-label").removeClass("active");
    });
    $(document).on('click',".doors-design-cst-width-apply-btn",function() {
      var inputheight = $(".doors-design-width-inch").val();
      var selectfaction = $(".custom_width_fraction").val();
      if (inputheight !== "" && selectfaction !== null) {
        $(".doors-cst-width").val(inputheight + ' / ' + selectfaction);  
        $(".doors-cst-width").click();
      }       
    });

    $(document).on('click','.doors-design-nav-reset',function() {
      total = 0;
      $("input[type='hidden'], .doors-design-cst-form-column input[type='number'], textarea").val('');
      $(".doors-design-value-price, .doors-design-final-price").text(Shopify.formatMoney('0'));
      $("input[type='hidden']").remove();
      $("input[type='radio']").prop('checked', false);
      $(".doors-cst-width-form-open, .doors-cst-height-form-open, .doors-design-field-flex").css("display", "none");
      $(".doors-cst-width-label, .doors-cst-height-label").removeClass("active");
      $("body").addClass("reset-step-form");
      updateStepVisibility();
    });
});


